// src/components/Landing/LandingPage.js
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './CompleteLandingPage.css';
import SystemCarousel from './SystemCarousel';
import LogoCarousel from './LogoCarousel';
import PrivacyModal from './PrivacyModal';

const API_URL = process.env.REACT_APP_API_URL || 'http://http://https://southamerica-east1-drecenna.cloudfunctions.net/api';

const LandingPage = () => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [billingCycle, setBillingCycle] = useState('monthly');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentFeatureIndex, setCurrentFeatureIndex] = useState(0);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  useEffect(() => {
    if (location.hash === '#politica') {
      setIsPrivacyModalOpen(true);
    }
  }, [location.hash]);

  const handleNextFeature = () => {
    setCurrentFeatureIndex((prevIndex) => (prevIndex + 1) % featuresData.length);
  };

  const handlePrevFeature = () => {
    setCurrentFeatureIndex((prevIndex) => (prevIndex - 1 + featuresData.length) % featuresData.length);
  };

  const featuresData = [
    {
      icon: (
        <svg viewBox="0 0 24 24" width="32" height="32">
          <rect x="2" y="3" width="20" height="18" rx="2" />
          <path d="M8 10h8M8 14h4" />
        </svg>
      ),
      title: "Comandas Inteligentes",
      description: "Adição e controle de itens em tempo real, de maneira rápida, intuitiva e organizada.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" width="32" height="32">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8v8M8 12h8" />
        </svg>
      ),
      title: "Estoque por Ingredientes",
      description: "Controle de insumos, reposições e alertas de baixa, com cálculo automático de CMV real e estimado.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" width="32" height="32">
          <path d="M12 20V10M18 20V4M6 20v-6" />
        </svg>
      ),
      title: "Dashboard Inteligente",
      description: "Todos os dados mais importantes do seu estabelecimento, organizados e gerados automaticamente em gráficos e relatórios claros e fáceis de entender.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" width="32" height="32">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
        </svg>
      ),
      title: "Relatorios Diarios automaticos no Whatsapp",
      description: "Receba dados de faturamento, produtos mais vendidos, ticket médio e outras informações de gestão diariamente no seu Whatsapp.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" width="32" height="32">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      ),
      title: "Controle de Clientes",
      description: "Aplique descontos, acompanhe clientes recorrentes e entenda a preferência de cada cliente.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" width="32" height="32">
          <rect x="5" y="3" width="14" height="18" rx="2"></rect>
          <line x1="9" y1="8" x2="15" y2="8"></line>
          <line x1="9" y1="12" x2="15" y2="12"></line>
          <line x1="9" y1="16" x2="13" y2="16"></line>
        </svg>
      ),
      title: "Integração NFC-e / NF-e",
      description: "Emissão automática de NFC-e a cada venda e captura automática das notas fiscais emitidas por fornecedores no CNPJ da empresa.",
    },
  ];

  const navLinksRef = useRef(null);
  const menuToggleRef = useRef(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Efeito para fechar o menu ao clicar fora ou rolar a página
  useEffect(() => {
    if (!isMobileMenuOpen) {
      return;
    }

    const handleClickOutside = (event) => {
      if (
        navLinksRef.current && !navLinksRef.current.contains(event.target) &&
        menuToggleRef.current && !menuToggleRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    const handleScroll = () => {
      setIsMobileMenuOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobileMenuOpen]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const rotatingWords = ['Restaurante', 'Bar', 'Café', 'Balada'];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % rotatingWords.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (featuresData.length > 0) {
      const timer = setInterval(() => {
        setCurrentFeatureIndex(prevIndex => (prevIndex + 1) % featuresData.length);
      }, 5000);

      return () => clearInterval(timer);
    }
  }, [currentFeatureIndex, featuresData.length]);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 100;
      if (scrolled !== isVisible) {
        setIsVisible(scrolled);
      }
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('lp-animate-in');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.lp-animate-on-scroll').forEach(element => {
      observer.observe(element);
    });

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, [isVisible]);

  const handleBillingCycleToggle = () => {
    setBillingCycle(prev => (prev === 'monthly' ? 'annual' : 'monthly'));
  };

  const handleMobileLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="landing-page-root">
      <div className="lp-container">
        <div className="lp-bg-gradient"></div>
        <div className="lp-bg-pattern"></div>
        <div className="lp-bg-shape lp-shape-1"></div>
        <div className="lp-bg-shape lp-shape-2"></div>
        <div className="lp-bg-shape lp-shape-3"></div>

        <nav className={`lp-nav ${isVisible ? 'lp-nav-scrolled' : ''} ${isMobileMenuOpen ? 'lp-mobile-open' : ''}`}>
          <div className="lp-nav-logo">
            <img src="/logolandingpage.png" alt="CripSYS Logo" />
          </div>
          <div ref={navLinksRef} className="lp-nav-links">
            <a href="#como-funciona" className="lp-nav-link" onClick={handleMobileLinkClick}>Como Funciona</a>
            <a href="#funcionalidades" className="lp-nav-link" onClick={handleMobileLinkClick}>Funcionalidades</a>
            <a href="#beneficios" className="lp-nav-link" onClick={handleMobileLinkClick}>Benefícios</a>
            <a href="#planos" className="lp-nav-link" onClick={handleMobileLinkClick}>Planos</a>
            <a href="#depoimentos" className="lp-nav-link" onClick={handleMobileLinkClick}>Depoimentos</a>

            <a
              href="https://wa.me/554195211928"
              className="lp-btn lp-btn-primary lp-nav-contact-btn"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleMobileLinkClick}
            >
              Entre em contato
            </a>
          </div>
          <div ref={menuToggleRef} className="lp-mobile-menu-toggle" onClick={toggleMobileMenu}>
            <div className="lp-hamburger"></div>
          </div>
        </nav>

        {/* O resto do seu código JSX permanece o mesmo */}
        <section className="lp-hero-section">
          <div className="lp-hero-content lp-animate-on-scroll">
            {isMobile ? (
              <h1 className="lp-glowing-text">
                <span className="lp-h1-line">Gestão inteligente</span>
                <span className="lp-h1-line">para seu </span>
                <span className="lp-h1-line">
                  <span
                    key={currentWordIndex}
                    className="lp-rotating-text"
                  >
                    {rotatingWords[currentWordIndex]}
                  </span>
                </span>
              </h1>
            ) : (
              <h1 className="lp-glowing-text">
                <span className="lp-h1-line">Gestão inteligente</span>
                <span className="lp-h1-line">
                  para seu{' '}
                  <span
                    key={currentWordIndex}
                    className="lp-rotating-text"
                  >
                    {rotatingWords[currentWordIndex]}
                  </span>
                </span>
              </h1>
            )}
            <p className="lp-hero-description">
              Controle comandas, estoque, vendas, relatórios e muito mais em um só lugar. Tudo que seu estabelecimento precisa, em uma plataforma tecnológica e intuitiva.
            </p>
            <div className="lp-hero-buttons">
              <a href="https://wa.me/554195211928?text=Ol%C3%A1%2C%20quero%20ver%20o%20CripSYS%20funcionando%20na%20pr%C3%A1tica." target="_blank" rel="noopener noreferrer" className="lp-btn lp-btn-primary">
                <span>Agende sua demonstração</span>
                <svg className="lp-btn-arrow" viewBox="0 0 24 24" width="24" height="24">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
              <a href="#planos" className="lp-btn lp-btn-secondary">
                <span>Ver Planos</span>
              </a>
            </div>
          </div>
          <div className="lp-hero-image">
            <picture>
              <source media="(max-width: 768px)" srcSet="/prints/dashboard-mobile.png" />
              <source media="(min-width: 769px)" srcSet="/prints/dashboard-desktop.png" />
              <img src="/prints/dashboard-desktop.png" alt="Dashboard CripSYS" className="lp-dashboard-preview lp-animate-on-scroll" />
            </picture>
          </div>
        </section>


        <LogoCarousel />

        <section id="como-funciona" className="lp-how-it-works-section">
          <div className="lp-section-header lp-animate-on-scroll">
            <div className="lp-section-badge">Simples e Eficiente</div>
            <h2>Como o CripSYS Funciona</h2>
            <p>Três passos simples para transformar sua gestão</p>
          </div>
          <div className="lp-steps-container">
            <div className="lp-step-card lp-animate-on-scroll">
              <div className="lp-step-number">1</div>
              <div className="lp-step-content">
                <div className="lp-step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    style={{ strokeWidth: 1 }} stroke-linecap="round" stroke-linejoin="round"
                    aria-labelledby="title" role="img">
                    <title>Ícone de Cardápio</title>
                    <rect x="2" y="4" width="10" height="16" rx="2" />
                    <rect x="12" y="4" width="10" height="16" rx="2" />
                    <path d="M12 6v12" />
                    <path d="M4 8h6M4 11h6M4 14h6M4 17h6" />
                    <path d="M14 8h6M14 11h6M14 14h6M14 17h6" />
                  </svg>



                </div>
                <h3>Organize seu cardápio</h3>
                <p>Use inteligência artificial para ler seu cardápio e montar o menu digital com produtos, categoriase e preços.</p><p> Fácil de usar, fácil de vender.</p>
              </div>
            </div>
            <div className="lp-step-connector"></div>
            <div className="lp-step-card lp-animate-on-scroll">
              <div className="lp-step-number">2</div>
              <div className="lp-step-content">
                <div className="lp-step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    style={{ strokeWidth: 1 }} stroke-linecap="round" stroke-linejoin="round"
                    aria-labelledby="title" role="img">
                    <title>Ícone de Cifrão</title>
                    <path d="M10.5 1v22" />
                    <path d="M13.5 1v22" />
                    <path d="M17 7.5c0-2.5-2-4.5-5-4.5s-5 2-5 4.5 2 3.5 5 3.5 5 1 5 3.5-2 4.5-5 4.5-5-2-5-4.5" />
                  </svg>




                </div>
                <h3>Gerencie vendas e comandas</h3>
                <p>Acompanhe pedidos em tempo real, calcule automaticamente o pico de movimento e aplique descontos de fidelidade.</p>
              </div>
            </div>
            <div className="lp-step-connector"></div>
            <div className="lp-step-card lp-animate-on-scroll">
              <div className="lp-step-number">3</div>
              <div className="lp-step-content">
                <div className="lp-step-icon">
                  <svg viewBox="0 0 24 24" width="48" height="48">
                    <path d="M12 20V10M18 20V4M6 20v-6" />
                  </svg>
                </div>
                <h3>Relatórios que te ajudam a crescer</h3>
                <p>Visualize o desempenho do dia, do turno ou do mês com dashboards e controle de caixa.</p>
              </div>
            </div>
          </div>
        </section>

        <SystemCarousel />

        <section className="lp-demo-cta-section lp-animate-on-scroll">
          <a
            href="https://wa.me/554195211928?text=Ol%C3%A1%2C%20quero%20ver%20o%20CripSYS%20funcionando%20na%20pr%C3%A1tica."
            target="_blank"
            rel="noopener noreferrer"
            className="lp-btn lp-btn-primary"
          >
            <span>Agendar Demonstração Agora</span>
            <svg className="lp-btn-arrow" viewBox="0 0 24 24" width="24" height="24">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </section>

        <section id="funcionalidades" className="lp-features-section">
          <div className="lp-section-header lp-animate-on-scroll">
            <div className="lp-section-badge">Recursos Exclusivos</div>
            <h2>Funcionalidades pensadas para seu food service</h2>
            <p>Ferramentas completas para otimizar sua gestão</p>
          </div>

          {/* ================================================= */}
          {/* ========= SUBSTITUA O TRECHO ANTIGO POR ESTE ========= */}
          {/* ================================================= */}

          {/* RENDERIZA O CARROSSEL EM TELAS MÓVEIS */}
          <div className="lp-features-carousel-container lp-animate-on-scroll">
            <button
              className="lp-features-carousel-control lp-prev"
              onClick={handlePrevFeature}
              aria-label="Funcionalidade Anterior"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>

            <div
              className="lp-features-carousel-wrapper"
              style={{ transform: `translateX(-${currentFeatureIndex * 100}%)` }}
            >
              {featuresData.map((feature, index) => (
                <div className="lp-features-carousel-slide" key={index}>
                  <div className="lp-feature-card">
                    <div className="lp-feature-icon">
                      <div className="lp-icon-bg"></div>
                      {feature.icon}
                    </div>
                    <div className="lp-feature-content">
                      <h3>{feature.title}</h3>
                      <p>{feature.description}</p>
                    </div>
                    <div className="lp-feature-hover"></div>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="lp-features-carousel-control lp-next"
              onClick={handleNextFeature}
              aria-label="Próxima Funcionalidade"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>

            <div className="lp-features-carousel-indicators">
              {featuresData.map((_, index) => (
                <button
                  key={index}
                  className={`lp-features-carousel-indicator ${currentFeatureIndex === index ? 'lp-active' : ''}`}
                  onClick={() => setCurrentFeatureIndex(index)}
                  aria-label={`Ir para a funcionalidade ${index + 1}`}
                />
              ))}
            </div>
          </div>

          {/* RENDERIZA O GRID EM DESKTOPS */}
          <div className="lp-features-grid">
            {featuresData.map((feature, index) => (
              <div className="lp-feature-card lp-animate-on-scroll" key={index}>
                <div className="lp-feature-icon">
                  <div className="lp-icon-bg"></div>
                  {feature.icon}
                </div>
                <div className="lp-feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
                <div className="lp-feature-hover"></div>
              </div>
            ))}
          </div>
          {/* ================================================= */}
          {/* ================================================= */}
        </section>

        <section id="planos" className="lp-pricing-section">
          <div className="lp-section-header lp-animate-on-scroll">
            <div className="lp-section-badge">Transparência Total</div>
            <h2>Planos que crescem com seu estabelecimento</h2>
            <p>Para quem está começando ou quem já tem operação rodando</p>
          </div>

          <div className="lp-pricing-toggle lp-animate-on-scroll">
            <span className={billingCycle === 'monthly' ? 'lp-active' : ''} onClick={() => setBillingCycle('monthly')}>
              Mensal
            </span>
            <div className="lp-toggle-switch" onClick={handleBillingCycleToggle}>
              <div className={`lp-toggle-slider ${billingCycle === 'annual' ? 'lp-active' : ''}`}></div>
            </div>
            <span className={billingCycle === 'annual' ? 'lp-active' : ''} onClick={() => setBillingCycle('annual')}>
              Anual
            </span>
          </div>

          <div className="lp-pricing-plans lp-animate-on-scroll">
            <div className="lp-pricing-card">
              <div className="lp-card-header">
                <h3>Plano Básico</h3>
                <div className="lp-price">
                  <span className="lp-currency">R$</span>
                  <span className="lp-amount" style={{ color: billingCycle === 'annual' ? '#fbbc05' : '' }}>
                    {billingCycle === 'monthly' ? '199' : '159'}
                  </span>
                  <span className="lp-period">/mês</span>
                </div>
                <p className="lp-card-description">Ideal para quem deseja sair do controle manual e migrar para uma gestão digital simplificada</p>
              </div>
              <div className="lp-card-features">
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>PDV Balcão / Mesa</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Comandas Individuais</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Cardápio Digital + QR Code</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Aplicativo para Garçom (Celular/Tablet)</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Aplicativo para Proprietário (Celular/Tablet)</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Gestão Básica de Produtos</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Cupom de Desconto</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Dividir / Juntar Comandas</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Taxa de Serviço</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Controle de Ponto Básico</span>
                </div>
              </div>
              <div className="lp-card-footer">
                <a
                  href={`https://wa.me/554195211928?text=${encodeURIComponent(`Olá! Tenho interesse no Plano Básico (${billingCycle === 'monthly' ? 'Mensal' : 'Anual'}).`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`lp-btn ${billingCycle === 'monthly' ? 'lp-btn-outline' : 'lp-btn-outline-annual'}`}
                >
                  Contratar via WhatsApp
                </a>
              </div>
            </div>
            {/* ================================================= */}
            {/* ========= MODIFICAÇÃO APLICADA AQUI ========= */}
            {/* ================================================= */}
            <div className="lp-pricing-card">
              <div className="lp-card-header">
                <h3>Plano Inovação</h3>
                <div className="lp-price">
                  <span className="lp-currency">R$</span>
                  <span className="lp-amount" style={{ color: billingCycle === 'annual' ? '#fbbc05' : '' }}>
                    {billingCycle === 'monthly' ? '279' : '239'}
                  </span>
                  <span className="lp-period">/mês</span>
                </div>
                <p className="lp-card-description">Ideal para quem quer inovar no atendimento e entender melhor o perfil dos seus clientes</p>
              </div>
              {/* ... features e footer permanecem os mesmos ... */}
              <div className="lp-card-features">
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span><strong>Tudo do Plano Básico +</strong></span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Dashboard Completo</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Auditoria de Caixa</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Gestão de Estoque</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Gestão Financeira</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Painel KDS (Cozinha)</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Relatórios Completos e Curva ABC</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Controle de Despesas e Fornecedores</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>NFC-e / NF-e Ilimitadas</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>CPF na Nota</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Fidelidade de Clientes</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Suporte 24/7</span>
                </div>
              </div>
              <div className="lp-card-footer">
                <a
                  href={`https://wa.me/554195211928?text=${encodeURIComponent(`Olá! Tenho interesse no Plano Inovação (${billingCycle === 'monthly' ? 'Mensal' : 'Anual'}).`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`lp-btn ${billingCycle === 'monthly' ? 'lp-btn-primary' : 'lp-btn-outline-annual'}`}
                >
                  Contratar via WhatsApp
                </a>
              </div>
            </div>
            <div className={`lp-pricing-card lp-popular ${billingCycle === 'monthly' ? 'lp-popular-monthly-special' : 'lp-popular-annual'}`}>
              <div className="lp-card-badge">Mais Popular</div>
              <div className="lp-card-header">
                <h3>Plano Profissional</h3>
                {billingCycle === 'monthly' ? (
                  <div className="lp-price">
                    <span className="lp-currency">R$</span>
                    <span className="lp-amount" style={{ color: '#fbbc05' }}>
                      499
                    </span>
                    <span className="lp-period">/mês</span>
                  </div>
                ) : (
                  <div className="lp-price">
                    <span className="lp-currency">R$</span>
                    <span className="lp-amount" style={{ color: '#fbbc05' }}>
                      399
                    </span>
                    <span className="lp-period">/mês</span>
                  </div>
                )}
                <p className="lp-card-description">Ideal para quem busca digitalizar completamente a operação, integrando processos e aumentando a eficiência</p>
              </div>
              {/* ... features e footer permanecem os mesmos ... */}
              <div className="lp-card-features">
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span><strong>Tudo do Plano Inovação +</strong></span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>
                    Cadastro de Nota Fiscal
                    <span className="lp-ai-text">(automatizado por I.A)</span>
                  </span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>
                    Cadastro de Cardápio
                    <span className="lp-ai-text">(automatizado por I.A)</span>
                  </span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>
                    Relatório diário inteligente no Whatsapp
                  </span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>
                    Cadastro de NFC-e de Despesa
                    <span className="lp-ai-text">(automatizado por I.A)</span>
                  </span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Emissão/Controle NF-e</span>
                </div>

                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Relatório DRE (Demonstrativo de Resultados)</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>CMV Real / CMV Estimado</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Integração com Impressora Térmica</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Integração com Balança Buffet</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Integração com Totem Self-Service</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Integração com TEF</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Self-Service no QR Code (Celular)</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20"><path d="M9 11l3 3L22 4" /></svg>
                  <span>Gestão de Portaria e Listas VIP</span>
                </div>

              </div>
              <div className="lp-card-footer">
                <a
                  href={`https://wa.me/554195211928?text=${encodeURIComponent(`Olá! Tenho interesse no Plano Profissional (${billingCycle === 'monthly' ? 'Mensal' : 'Anual'}).`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`lp-btn ${billingCycle === 'monthly' ? 'lp-btn-primary' : 'lp-btn-primary-annual'}`}
                >
                  Contratar via WhatsApp
                </a>
              </div>
            </div>
          </div>
          {/* ================================================= */}
          {/* =ANULADO: O CSS já lida com isso se a classe correta for aplicada */}
          {/* ================================================= */}
          <div className={`lp-enterprise-option lp-animate-on-scroll ${billingCycle === 'annual' ? 'lp-annual-active' : ''}`}>
            <div className="lp-enterprise-content">
              <h3>Precisa de um plano personalizado?</h3>
              <p>Para empresas com necessidades específicas, oferecemos soluções personalizadas.</p>
            </div>
            <a href="https://wa.me/554195211928?text=Ol%C3%A1%2C%20quero%20ver%20o%20CripSYS%20funcionando%20na%20pr%C3%A1tica." target="_blank" rel="noopener noreferrer" className="lp-btn lp-btn-outline-light">
              Fale com nossa Equipe
            </a>
          </div>
          <div className="lp-pricing-faqs lp-animate-on-scroll">
            <h3>Perguntas Frequentes</h3>
            <div className="lp-faq-grid">
              <div className="lp-faq-item">
                <h4>Quais são os principais benefícios de usar o sistema da CripSYS?</h4>
                <p>Com o CripSYS, você gerencia pedidos, estoque, finanças, clientes e processos fiscais em um só lugar, de forma prática e eficiente — sem precisar de outro sistema.</p>
              </div>
              <div className="lp-faq-item">
                <h4>Existe alguma taxa de configuração?</h4>
                <p>Não cobramos nenhuma taxa de configuração. Sempre que precisar, nossos especialistas estão prontos para ajudar gratuitamente na configuração e no uso da plataforma, garantindo uma experiência simples e eficiente desde o começo.</p>
              </div>
              <div className="lp-faq-item">
                <h4>O CripSYS oferece período de teste?</h4>
                <p>Embora não ofereçamos período de teste gratuito, garantimos suporte completo para que você tenha a melhor experiência desde o início. Escolha o plano ideal para suas necessidades e conte com nossa equipe em cada passo!</p>
              </div>
              <div className="lp-faq-item">
                <h4>Posso mudar de plano a qualquer momento?</h4>
                <p>Você tem total liberdade para fazer upgrade ou downgrade do seu plano a qualquer momento, com mudanças aplicadas de forma imediata para sua conveniência.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="beneficios" className="lp-benefits-section">
          <div className="lp-section-header lp-animate-on-scroll">
            <div className="lp-section-badge">Não Fique Para Trás</div>
            <h2>O que as empresas de sucesso já estão fazendo</h2>
            <p>Enquanto você se preocupa com a gestão manual, sua concorrência está usando tecnologia para crescer. Veja por que você precisa do CripSYS agora.</p>
          </div>
          <div className="lp-benefits-container">
            <div className="lp-benefit-card lp-animate-on-scroll">
              <div className="lp-benefit-number">01</div>
              <div className="lp-benefit-icon">
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </div>
              <h3>Pare de perder tempo</h3>
              <p>Sua equipe gasta horas em tarefas manuais que poderiam ser automatizadas. Enquanto isso, seus concorrentes estão focados em estratégias de crescimento. O CripSYS te dá de volta o tempo que você precisa.</p>
              <div className="lp-benefit-stat">
                <div className="lp-stat-value">85%</div>
                <div className="lp-stat-label">Menos tempo em tarefas manuais</div>
              </div>
            </div>
            <div className="lp-benefit-card lp-animate-on-scroll">
              <div className="lp-benefit-number">02</div>
              <div className="lp-benefit-icon">
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" />
                  <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" />
                </svg>
              </div>
              <h3>Decisões no escuro?</h3>
              <p>Sem dados, você está adivinhando o que funciona. As empresas que usam tecnologia têm 3x mais informações para tomar decisões certeiras, superando quem ainda depende do "achismo".</p>
              <div className="lp-benefit-stat">
                <div className="lp-stat-value">3X</div>
                <div className="lp-stat-label">Mais informações para decisões</div>
              </div>
            </div>
            <div className="lp-benefit-card lp-animate-on-scroll">
              <div className="lp-benefit-number">03</div>
              <div className="lp-benefit-icon">
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <path d="M9 11l3 3L22 4" />
                  <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
                </svg>
              </div>
              <h3>Risco de erros fiscais</h3>
              <p>Erros fiscais podem custar caro. Enquanto outros negócios garantem 100% de conformidade com sistemas automatizados, você pode estar expondo sua empresa a multas e retrabalho desnecessário.</p>
              <div className="lp-benefit-stat">
                <div className="lp-stat-value">100%</div>
                <div className="lp-stat-label">Conformidade com a legislação</div>
              </div>
            </div>
            <div className="lp-benefit-card lp-animate-on-scroll">
              <div className="lp-benefit-number">04</div>
              <div className="lp-benefit-icon">
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <path d="M13 7h8m-8 4h8m-8 4h8M3 7h2v10H3zM9 7H7v10h2z" />
                </svg>
              </div>
              <h3>Você pode estar gastando demais</h3>
              <p>Você sabe exatamente onde seu dinheiro está indo? Empresas que usam o CripSYS já cortaram 33% de seus custos em média. Cada dia sem um sistema inteligente é dinheiro que você pode estar perdendo.</p>
              <div className="lp-benefit-stat">
                <div className="lp-stat-value">33%</div>
                <div className="lp-stat-label">Média de redução de custos</div>
              </div>
            </div>
            <div className="lp-benefit-card lp-animate-on-scroll">
              <div className="lp-benefit-number">05</div>
              <div className="lp-benefit-icon">
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <h3>Sua concorrência fideliza clientes, e você?</h3>
              <p>Enquanto outros estabelecimentos usam a tecnologia para rastrear e recompensar clientes fiéis, você está perdendo a oportunidade de criar uma comunidade e garantir que eles voltem sempre.</p>
              <div className="lp-benefit-stat">
                <div className="lp-stat-value">25%</div>
                <div className="lp-stat-label">Aumento na fidelidade do cliente</div>
              </div>
            </div>
            <div className="lp-benefit-card lp-animate-on-scroll">
              <div className="lp-benefit-number">06</div>
              <div className="lp-benefit-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  style={{ strokeWidth: 1.4 }} stroke-linecap="round" stroke-linejoin="round"
                  aria-labelledby="title" role="img">
                  <title>Ícone de Cifrão</title>
                  <path d="M10.5 1v22" />
                  <path d="M13.5 1v22" />
                  <path d="M17 7.5c0-2.5-2-4.5-5-4.5s-5 2-5 4.5 2 3.5 5 3.5 5 1 5 3.5-2 4.5-5 4.5-5-2-5-4.5" />
                </svg>
              </div>
              <h3>Perdendo dinheiro com estoque?</h3>
              <p>A gestão manual de estoque leva a desperdícios e perdas de vendas por falta de produtos. Seus concorrentes já otimizaram esse processo para garantir margens de lucro maiores.</p>
              <div className="lp-benefit-stat">
                <div className="lp-stat-value">15%</div>
                <div className="lp-stat-label">Redução em desperdício de insumos</div>
              </div>
            </div>
          </div>
        </section>

        <section className="lp-demo-cta-section lp-animate-on-scroll">
          <a
            href="https://wa.me/554195211928?text=Ol%C3%A1%2C%20quero%20ver%20o%20CripSYS%20funcionando%20na%20pr%C3%A1tica."
            target="_blank"
            rel="noopener noreferrer"
            className="lp-btn lp-btn-primary"
          >
            <span>Agendar Demonstração Agora</span>
            <svg className="lp-btn-arrow" viewBox="0 0 24 24" width="24" height="24">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </section>

        <section id="depoimentos" className="lp-testimonials-section">
          <div className="lp-section-header lp-animate-on-scroll">
            <div className="lp-section-badge">Casos de Sucesso</div>
            <h2>O Que Nossos Clientes Dizem</h2>
            <p>Histórias reais de empresas que transformaram sua gestão com o CripSYS</p>
          </div>
          <div className="lp-testimonials-container">
            <div className="lp-testimonial-card lp-animate-on-scroll">
              <div className="lp-testimonial-rating">
                <span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span>
              </div>
              <div className="lp-testimonial-content">
                <p>"Antes, eu vivia atolado em planilhas tentando controlar estoque, pedidos e comandas, e parecia que sempre faltava alguma coisa. Com o CripSYS, tudo mudou. Agora tenho uma visão completa do bar na palma da mão: sei o que está vendendo mais, o que precisa repor e consigo acompanhar cada comanda em tempo real. Tornou a gestão muito mais simples e nos deu mais tempo para focar no que realmente importa: atender bem os clientes."</p>              </div>
              <div className="lp-testimonial-author">
                <div className="lp-author-avatar"><div className="lp-avatar-circle">EV</div></div>
                <div className="lp-author-info"><h4>Élcio Venturi</h4><p>Proprietário do Cenna Cinco</p></div>
              </div>
            </div>
            <div className="lp-testimonial-card lp-animate-on-scroll">
              <div className="lp-testimonial-rating">
                <span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span>
              </div>
              <div className="lp-testimonial-content">
                <p>"Começamos a usar o CripSYS há alguns meses e a diferença foi imediata. Antes, era difícil acompanhar todos os pedidos, o estoque e as finanças ao mesmo tempo, e acabávamos perdendo tempo e dinheiro. Com o sistema, conseguimos organizar tudo em um só lugar de forma simples e prática. Hoje, sabemos exatamente o que está vendendo mais, o que precisa ser reposto e conseguimos atender nossos clientes de forma muito mais ágil. Realmente mudou a maneira como gerenciamos a cafeteria, e a equipe toda se adaptou rápido. Recomendo de coração."</p>
              </div>
              <div className="lp-testimonial-author">
                <div className="lp-author-avatar"><div className="lp-avatar-circle">SP</div></div>
                <div className="lp-author-info"><h4>Sandreli Pomplona</h4><p>Proprietária do Ué Pet Café</p></div>
              </div>
            </div>
            <div className="lp-testimonial-card lp-animate-on-scroll">
              <div className="lp-testimonial-rating">
                <span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span>
              </div>
              <div className="lp-testimonial-content">
                <p>"O que mais me surpreendeu no CripSYS foi como é fácil de usar. Não precisei de nenhum manual para montar o cardápio e gerenciar os pedidos do dia a dia. O dashboard é um diferencial enorme: consigo ver o pico de movimento, faturamento por dia da semana e todas as informações importantes de um jeito claro, me ajudando a tomar decisões rápidas e inteligentes sem complicação. Sério, facilitou demais a rotina da cafeteria."</p>              </div>
              <div className="lp-testimonial-author">
                <div className="lp-author-avatar"><div className="lp-avatar-circle">LF</div></div>
                <div className="lp-author-info"><h4>Luiz Feller</h4><p>Proprietário da Asteristico</p></div>
              </div>
            </div>
          </div>
        </section>

        <section className="lp-cta-section">
          <div className="lp-cta-background">
            <div className="lp-cta-shape lp-shape-1"></div><div className="lp-cta-shape lp-shape-2"></div><div className="lp-cta-shape lp-shape-3"></div>
          </div>
          <div className="lp-cta-content lp-animate-on-scroll">
            <div className="lp-cta-badge"><span>Comece Hoje Mesmo</span></div>
            <h2>Pronto para transformar a gestão do seu estabelecimento?</h2>
            <p>Junte-se aos estabelecimentos que já otimizaram seus processos com o CripSYS.</p>
            <div className="lp-cta-features">
              <div className="lp-cta-feature"><svg className="lp-feature-check" viewBox="0 0 24 24" width="24" height="24"><path d="M9 11l3 3L22 4" /></svg><span>Configuração rápida</span></div>
              <div className="lp-cta-feature"><svg className="lp-feature-check" viewBox="0 0 24 24" width="24" height="24"><path d="M9 11l3 3L22 4" /></svg><span>Suporte especializado</span></div>
              <div className="lp-cta-feature"><svg className="lp-feature-check" viewBox="0 0 24 24" width="24" height="24"><path d="M9 11l3 3L22 4" /></svg><span>Resultados imediatos</span></div>
            </div>
            <div className="lp-cta-buttons">
              <a href="https://wa.me/554195211928?text=Ol%C3%A1%2C%20quero%20ver%20o%20CripSYS%20funcionando%20na%20pr%C3%A1tica." target="_blank" rel="noopener noreferrer" className="lp-btn lp-btn-outline-light">
                <span>Agendar Demo</span>
                <svg className="lp-btn-arrow" viewBox="0 0 24 24" width="20" height="20"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
              </a>
              <a href="#planos" className="lp-btn lp-btn-primary">
                <span>Ver Planos</span>
                <svg className="lp-btn-arrow" viewBox="0 0 24 24" width="20" height="20">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>
        </section>

        <footer className="lp-footer">
          <div className="lp-footer-content">
            <div className="lp-footer-logo">
              <img src="/prints/logolandingpagebranca.png" alt="CripSYS Logo" className="lp-footer-logo-img" />
              <p>Gestão inteligente para seu estabelecimento</p>
              <div className="lp-social-icons">
                <a href="#" className="lp-social-icon"><span>FB</span></a><a href="#" className="lp-social-icon"><span>TW</span></a><a href="#" className="lp-social-icon"><span>IG</span></a><a href="#" className="lp-social-icon"><span>LI</span></a>
              </div>
            </div>
            <div className="lp-footer-links">
              <div className="lp-footer-column">
                <h4>Contato</h4>
                <a
                  href="https://wa.me/554195211928?text=Ol%C3%A1%2C%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20CripSYS."
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Fale Conosco
                </a>
              </div>

              <div className="lp-footer-column">
                <h4>Navegação</h4>
                <a href="#como-funciona">Como Funciona</a>
                <a href="#funcionalidades">Funcionalidades</a>
                <a href="#beneficios">Benefícios</a>
                <a href="#planos">Planos</a>
                <a href="#depoimentos">Depoimentos</a>
              </div>

              <div className="lp-footer-column">
                <h4>Políticas de Dados</h4>
                <a href="#politica" onClick={(e) => { e.preventDefault(); setIsPrivacyModalOpen(true); }}>Política de Privacidade</a>
              </div>
            </div>
          </div>
          <div className="lp-footer-newsletter">
            <h4>Receba novidades por email</h4>
            <div className="lp-newsletter-form">
              <input type="email" placeholder="Seu email" />
              <button className="lp-btn-subscribe">Inscrever-se</button>
            </div>
          </div>
          <div className="lp-footer-bottom">
            <p>&copy; {new Date().getFullYear()} CripSYS. Todos os direitos reservados.</p>
          </div>
        </footer>

        <a
          href="https://wa.me/554195211928?text=Ol%C3%A1%2C%20quero%20ver%20o%20CripSYS%20funcionando%20na%20pr%C3%A1tica."
          className="lp-whatsapp-fab"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Fale conosco pelo WhatsApp"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.69-1.06-5.14-2.9-6.96zM12.04 20.15c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.23.86 5.82 2.45s2.45 3.62 2.45 5.82c0 4.54-3.7 8.24-8.24 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.7-.82s-.39-.12-.55.12c-.16.25-.64.82-.79.99s-.29.19-.54.06c-.25-.12-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72s-.03-.38.09-.51c.11-.11.25-.29.37-.43s.16-.25.25-.42c.09-.17.04-.31-.02-.43s-.55-1.32-.75-1.81c-.2-.48-.41-.42-.55-.42-.14 0-.3 0-.46 0s-.39.06-.6.31c-.2.25-.78.76-.78 1.85s.8 2.15.91 2.3s1.58 2.41 3.82 3.36c.55.24.98.38 1.32.48.55.16 1.05.14 1.45.09.44-.06 1.47-.6 1.68-1.18s.21-1.09.18-1.18c-.03-.09-.09-.15-.2-.25z" fill="white" />
          </svg>

          <span className="whatsapp-notification">1</span>
        </a>

      </div>

      <PrivacyModal isOpen={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} />
    </div>
  );
};

export default LandingPage;